import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, of, take, switchMap } from 'rxjs';

import { CustomizerSettingsService } from '../helpers/customizer-settings.service';
import { LocalStorageService } from '../helpers/localStorage.service';
import { AuthService } from './services/auth.service';

export const canActivate: CanActivateFn = () => {
  const authService = inject(AuthService);
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);
  const customizerService = inject(CustomizerSettingsService);

  customizerService.loading(true);

  return authService.checkToken().pipe(take(1),
    switchMap((res: any) => {
      if (!res) { // Se la chiamata non va a buon fine controllo se l'utente ha abilitato la funzionalità rememberMe durante la login (funzionalità che usa il refreshToken)
        if(localStorageService.getItem('remeberMe')){ // se il refreshToken è presente e impostato a true allora faccio il refresh
          authService.refreshToken().pipe(take(1),
            switchMap((res: any) => {
              if(res){ // se ricevo la risposta allora procedo nella pagina selezionata
                customizerService.loading(false)
                return of(true);
              }
              router.navigate(['/authentication/']);
              customizerService.loading(false)
              return of(false);
            })
          )
        }
        router.navigate(['/authentication/']);
        customizerService.loading(false)
        return of(false);
      }
      customizerService.loading(false)
      return of(true);
    }),
    catchError((err, caught) => {
      router.navigate(['/authentication/']);
      customizerService.loading(false)
      return of(false);
    })
  );
};
